export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9633.a996957a.jpg";